// i18n area 'tasks' — locale lv-LV (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.lv-LV.meta.json.
import type { enUS } from './tasks'

export const lvLV: typeof enUS = {
  macrotasks: {
    title: 'Makrotask',
    subtitle: 'Saliktas operācijas — atsākamas no neizdevušā soļa vai pārtraucamas',
    colType: 'Tips',
    colTarget: 'Objekts',
    colPhase: 'Fāze',
    colSteps: 'Soļi',
    empty: 'Nav neviena makrotask',
    detail: 'Detaļas',
    failedAt: 'neizdevās solī',
    resume: 'Mēģināt vēlreiz no neizdevušā soļa',
    abort: 'Pārtraukt visu',
    cancel: 'Atcelt',
    actionError: 'Darbība tika atteikta'
  },
  tasks: {
    title: 'Task',
    searchPlaceholder: 'Meklēt pēc tipa vai target',
    type: 'Tips',
    target: 'Target',
    phaseLabel: 'Fāze',
    progress: 'Progress',
    started: 'Sākts',
    finished: 'Beidzies',
    node: 'Mezgls',
    empty: 'Nav neviena task',
    loadError: 'Neizdevās ielādēt task — vai TVirt backend ir sasniedzams?',
    limboHint: "Mezgls '{node}' nav sasniedzams kopš {time} — task tur sava target write lease, līdz mezgls atgriežas vai tiek apliecināts kā izslēgts",
    nodeAttested: 'Mezgls apliecināts kā izslēgts',
    phase: {
      queued: 'Rindā',
      running: 'Izpildē',
      succeeded: 'Pabeigts',
      failed: 'Neizdevās',
      cancelled: 'Atcelts',
      'failed-at-step': 'Neizdevās kādā solī',
      aborted: 'Pārtraukts'
    },
    dropdown: {
      tooltip: 'Task izpildē',
      title: 'Task izpildē',
      empty: 'Nav neviena task izpildē',
      viewAll: 'Skatīt visus task'
    },
    detail: {
      open: 'Detaļas',
      scope: 'Tvērums',
      message: 'Ziņojums',
      params: 'Parametri',
      result: 'Rezultāts',
      errorTitle: 'Kļūda',
      steps: 'Soļi',
      failedAt: 'neizdevās solī',
      superseded: 'aizstāts',

      // Standarta dialogs (round #156): bērna vieta vecāka plānā,
      // pats vecāks (atverams uz vietas) un vainīgais solis.
      step: 'Solis',
      parent: 'Vecāka task',
      failedStep: 'Neizdevušais solis',
      log: 'Žurnāls',
      logEmpty: 'Vēl nav neviena žurnāla ieraksta',
      close: 'Aizvērt'
    },
    actions: {
      cancel: 'Atcelt',
      resume: 'Mēģināt vēlreiz no neizdevušā soļa',
      abort: 'Pārtraukt visu (atsaukt pabeigtos soļus)',
      refused: 'Darbība tika atteikta'
    }
  },
  events: {
    loadError: 'Neizdevās ielādēt žurnālu — vai TVirt aizmugursistēma ir sasniedzama?',
    title: 'Notikumi',
    subtitle: 'Klastera vēsturiskā atmiņa: notikuši fakti, sākot ar jaunākajiem',
    filterSeverity: 'Smagums',
    filterCategory: 'Kategorija',
    filterAll: 'Visas',
    searchLabel: 'Meklēt',
    searchPlaceholder: 'Meklēt visā žurnālā',
    subjectFilter: '{subject} notikumi — rādīt visus',
    colAt: 'Kad',
    colSeverity: 'Smagums',
    colType: 'Tips',
    colSubject: 'Objekts',
    colActor: 'Kas',
    colNode: 'Node',
    colMessage: 'Ziņojums',
    empty: 'Nav notikumu',
    loadMore: 'Ielādēt vairāk',
    actorSystem: 'sistēma',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Notikuma ID',
    taskCollectedHint: 'Task glabāšanas laiks ir īsāks: pēc savākšanas saite vairs neatbild',
    severity: {
      info: 'Informācija',
      warning: 'Brīdinājums',
      error: 'Kļūda',
      critical: 'Kritisks'
    },
    category: {
      lifecycle: 'Dzīves cikls',
      config: 'Konfigurācija',
      availability: 'Pieejamība',
      security: 'Drošība'
    },
    type: {
      haNetsvcFailedOver: 'Tīkla pakalpojuma failover',
      haNetsvcNoCandidate: 'Tīkla pakalpojums bez kandidāta mezgla',
      haNetsvcReaped: 'Lokālā instance nopļauta pēc mezgla atgriešanās',
      netsvcFloatipMoved: 'Peldošā IP pārvietota uz citu turētāju',
      netsvcFloatipNoHolder: 'Peldošā IP bez vesela mērķa',
      haAppFailedOver: 'App instances failover',
      haAppNoCandidate: 'App instance bez kandidāta mezgla',
      haAppStorageLocalSkip: 'App instance nav pārvietota: pastāvīgie dati ir lokāli mirušajā mezglā',
      haAppReaped: 'App instances lokālais pods nopļauts atgriežoties'
    }
  },
  audit: {
    loadError: 'Neizdevās ielādēt audita reģistru — vai TVirt aizmugursistēma ir sasniedzama?',
    title: 'Audits',
    subtitle: 'Kurš ko izdarīja, kad un ar kuru objektu — mēģinātās darbības, tostarp atteikumi',
    filterOutcome: 'Iznākums',
    filterAll: 'Visi',
    filterSudo: 'Tikai paaugstinātas darbības',
    colAt: 'Kad',
    colActor: 'Kas',
    colAction: 'Darbība',
    colTarget: 'Objekts',
    colOutcome: 'Iznākums',
    colNode: 'Node',
    empty: 'Nav reģistrētu darbību',
    loadMore: 'Ielādēt vairāk',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Maršruts',
    detailProblem: 'Iemesls',
    detailTask: 'Task',
    detailClientIp: 'No kurienes',
    detailId: 'Ieraksta ID',
    detailSession: 'Sesija',
    taskHint: 'Pieņemtas darbības iznākums dzīvo notikumu žurnālā, zem tā paša task id',
    outcome: {
      succeeded: 'Izdevās',
      accepted: 'Pieņemta',
      denied: 'Liegta',
      rejected: 'Noraidīta',
      failed: 'Neizdevās'
    }
  },
  notifications: {
    loadError: 'Neizdevās ielādēt paziņojumus — vai TVirt aizmugursistēma ir sasniedzama?',
    actionError: 'Darbība tika atteikta',
    title: 'Paziņojumi',
    subtitle: 'Galamērķi, uz kuriem žurnāla fakti pamet klasteri',
    rulesTitle: 'Noteikumi',
    rulesSubtitle: 'Kuri fakti iziet un uz kurieni',
    deliveriesTitle: 'Piegādes',
    deliveriesSubtitle: 'Katra paziņojuma iznākums ar iemeslu, kad tas neizdodas',
    colName: 'Nosaukums',
    colKind: 'Tips',
    colWhere: 'Kurp',
    colScope: 'Scope',
    colSeverity: 'Smagums',
    colMatch: 'Filtrs',
    colTargets: 'Galamērķis',
    colAt: 'Kad',
    colState: 'Stāvoklis',
    colEvent: 'Notikums',
    colAttempts: 'Mēģinājumi',
    colOutcome: 'Iznākums',
    empty: 'Nav rindu',
    matchAll: 'visi fakti',
    test: 'Pārbaudīt',
    testOk: 'Pārbaudes paziņojums piegādāts uz {target}',
    testFailed: 'Pārbaude uz {target} neizdevās: {reason}',
    retry: 'Atgriezt rindā',
    retried: 'Piegāde atgriezta rindā',
    grouped: 'un vēl {count} atkārtojumi',
    state: {
      failed: 'Neizdevās',
      pending: 'Rindā',
      sending: 'Tiek sūtīts',
      sent: 'Nosūtīts'
    },
    tabTargets: 'Mērķi',
    tabRules: 'Noteikumi',
    tabDeliveries: 'Piegādes',
    targetCreateTitle: 'Jauns mērķis',
    ruleCreateTitle: 'Jauns noteikums',
    nameHint: 'Mazie burti, cipari un domuzīmes; unikāls katrā tvērumā',
    kindImmutableHint: 'Nemainīgs: veida maiņa nozīmē cita mērķa izveidi',
    kindSmtp: 'Pasts (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Stāvoklis',
    enabledOn: 'Aktīvs',
    enabledOff: 'Apturēts',
    smtpHost: 'SMTP serveris',
    smtpPort: 'Ports',
    smtpPortHint: 'Parasti: 25 bez TLS, 587 ar starttls, 465 ar tls',
    smtpSecurity: 'Drošība',
    smtpFrom: 'Sūtītājs',
    smtpTo: 'Saņēmēji',
    smtpToHint: 'Viena vai vairākas adreses, atdalītas ar komatiem',
    webhookUrl: 'URL',
    payload: 'Saturs',
    payloadHint: 'Ar minimal notikuma ziņojums un dati neatstāj klasteri',
    credential: 'Akreditācijas dati',
    credentialNone: 'Nav',
    credentialHintSmtp: 'Releja konts no atslēgu krātuves; nav nozīmē anonīmu SMTP',
    credentialHintWebhook: 'Parakstīšanas noslēpums no atslēgu krātuves; bez paraksta jebkurš, kas zina URL, var uzdoties par klasteri',
    minSeverityHint: 'Slieksnis, nevis kopa: no šī smaguma un augstāk',
    categories: 'Kategorijas',
    categoriesHint: 'Tukšs = visas',
    types: 'Notikumu veidi',
    typesHint: 'Atdalīti ar komatiem; tukšs = visi. Nezināms veids tiek atteikts',
    targetsHint: 'Vismaz viens; tiem jābūt noteikuma tvērumā vai tā priekštecī',
    recursiveOn: 'Arī apakštvērumi',
    recursiveOff: 'Tikai šis tvērums',
    recursiveHint: 'Resursi dzīvo lapās: bez bērniem noteikums saknē paziņo gandrīz neko',
    repeatWindow: 'Grupēšanas logs (s)',
    repeatWindowHint: 'Loga ietvaros atkārtojumi nesūta pastu: tos skaita pirmajā. 0 atslēdz',
    targetInUseError: 'Mērķi {name} joprojām izmanto noteikums'
  }
}
